import { render } from "./OrderAutomation.vue?vue&type=template&id=56a88eef"
import script from "./OrderAutomation.vue?vue&type=script&lang=js"
export * from "./OrderAutomation.vue?vue&type=script&lang=js"
script.render = render

export default script